var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.867,
    height: 17.919,
    viewBox: "0 0 26.867 17.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "back-arrow-icon",
    d: "M17.615,11.595a1.219,1.219,0,0,1,.009,1.717L11.96,18.995H33.545a1.213,1.213,0,0,1,0,2.426H11.96L17.634,27.1a1.228,1.228,0,0,1-.009,1.717,1.208,1.208,0,0,1-1.708-.009l-7.69-7.746h0a1.362,1.362,0,0,1-.252-.383,1.158,1.158,0,0,1-.093-.467,1.216,1.216,0,0,1,.345-.849l7.69-7.746A1.189,1.189,0,0,1,17.615,11.595Z",
    transform: "translate(-7.882 -11.252)",
    fill: "#fbf8fd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.63de2e3190d1a2f406916049baa74855.svg";
export { ForwardRef as ReactComponent };